import type React from 'react';

import { useTranslation } from 'react-i18next';

import st from './FaceQualityChecks.module.sass';
import type { FaceQualityChecksRowProps } from './FaceQualityChecksRow';
import { FaceQualityChecksRow } from './FaceQualityChecksRow';

export interface FaceQualityChecksTableProps {
  checks: FaceQualityChecksRowProps[];
}

function FaceQualityChecksTable({
  checks,
}: FaceQualityChecksTableProps): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <table
      cellSpacing={0}
      className={st.Table}
    >
      <thead>
        <tr>
          <td>{t('checks:page.title.check')}</td>
          <td>{t('checks:page.title.result')}</td>
          <td>{t('checks:page.title.acceptable')}</td>
        </tr>
      </thead>
      <tbody>
        {checks.map((check) => (
          <FaceQualityChecksRow
            {...check}
            key={check.name}
          />
        ))}
      </tbody>
    </table>
  );
}

export { FaceQualityChecksTable };
